import { fetchAPI } from "../redux/api";

const read = async response => {
  if (!response.ok) {
    const text = await response.text();
    let message = "";
    try { message = JSON.parse(text).message || ""; } catch { /* non-JSON server response */ }
    if (!message && response.status >= 500) message = "The server could not complete this request. Please try again.";
    throw new Error(message || text || "Request failed.");
  }
  if (response.status === 204) return null;
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const advancedBillingApi = {
  getPayments: billId => fetchAPI(`GetBillPayments/${billId}`).then(read),
  correctPayments: (billId, payload) => fetchAPI(`advanced-billing/bills/${billId}/payments`, payload, "PUT").then(read),
  getAudit: billId => fetchAPI(`GetBillAudit/${billId}`).then(read),
  recordReprint: (billId, reason, terminalId) => fetchAPI(`RecordBillReprint/${billId}`, { reason, terminalId }, "POST").then(read),
  voidBill: (billId, request) => fetchAPI(`advanced-billing/bills/${billId}/void`,
    typeof request === "string" ? { reason: request } : request, "POST").then(read),
  refundBill: (billId, payload) => fetchAPI(`advanced-billing/bills/${billId}/refund`, payload, "POST").then(read),
  getRefunds: billId => fetchAPI(`advanced-billing/bills/${billId}/refunds`).then(read),
  getRefundReceipt: refundId => fetchAPI(`advanced-billing/refunds/${refundId}/receipt`).then(read),
  refreshRefund: refundId => fetchAPI(`advanced-billing/refunds/${refundId}/refresh`, {}, "POST").then(read),
  setManagerApprovalPin: pin => fetchAPI("advanced-billing/manager-approval-pin", { pin }, "PUT").then(read),
  getKotAdjustments: (status = "Pending") => fetchAPI(`advanced-billing/kot-adjustments?status=${encodeURIComponent(status)}`).then(read),
  acknowledgeKotAdjustment: adjustmentId => fetchAPI(`advanced-billing/kot-adjustments/${adjustmentId}/acknowledge`, {}, "POST").then(read),
  currentShift: () => fetchAPI("advanced-billing/shifts/current").then(read),
  shiftHistory: () => fetchAPI("advanced-billing/shifts").then(read),
  shiftSettings: () => fetchAPI("advanced-billing/shifts/settings").then(read),
  updateShiftSettings: payload => fetchAPI("advanced-billing/shifts/settings", payload, "PUT").then(read),
  openShift: openingCash => fetchAPI("advanced-billing/shifts/open", { openingCash }, "POST").then(read),
  shiftPreview: shiftId => fetchAPI(`advanced-billing/shifts/${shiftId}/preview`).then(read),
  shiftReport: shiftId => fetchAPI(`advanced-billing/shifts/${shiftId}/report`).then(read),
  closeShift: (shiftId, payload) => fetchAPI(`advanced-billing/shifts/${shiftId}/close`, payload, "POST").then(read),
  forceCloseShift: (shiftId, payload) => fetchAPI(`advanced-billing/shifts/${shiftId}/force-close`, payload, "POST").then(read),
  reopenShift: (shiftId, reason) => fetchAPI(`advanced-billing/shifts/${shiftId}/reopen`, { reason }, "POST").then(read),
  cashMovement: (shiftId, payload) => fetchAPI(`advanced-billing/shifts/${shiftId}/cash-movement`, payload, "POST").then(read),
  getTableTransferItems: tableNumber => fetchAPI(`advanced-billing/tables/${tableNumber}/transfer-items`).then(read),
  transferTableItems: payload => fetchAPI("advanced-billing/tables/items/transfer", payload, "POST").then(read),
  getTableOperationHistory: (take = 100) => fetchAPI(`advanced-billing/tables/operations?take=${take}`).then(read),
  undoTableOperation: (operationId, reason) => fetchAPI(`advanced-billing/tables/operations/${operationId}/undo`, { reason }, "POST").then(read),
  transferTable: payload => fetchAPI("advanced-billing/tables/transfer", payload, "POST").then(read),
  mergeTable: payload => fetchAPI("advanced-billing/tables/merge", payload, "POST").then(read)
};
